// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const TerminalLocationAddressRequirementsTable: MarkdocTagRegistration = {
  tag: 'terminal-location-address-requirements-table',
  component: 'TerminalLocationAddressRequirementsTable',
  attributes: {
    addressRequirementsByCountry: {
      type: Object,
      required: true,
      localizable: false,
      description:
        'Location validation requirements for countries from the terminal context',
    },
    compatibilityData: {
      type: Object,
      required: true,
      description: 'Terminal compatibility data from the terminal context',
      localizable: false,
    },
  },
};
